<app-basic-avatar
  [name]="name"
  [size]="size"
  [badgeSize]="badgeSize"
  [badgeSrc]="badgeSrc"
  [src]="src | async"
  [fallback]="fallback"
  (imageError)="onError()"
></app-basic-avatar>
